import React, { useEffect, useState } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './tickets.css';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'react-bootstrap';
import UploadIcon from '../../assets/icons/ticket/upload.svg'
import { getMessageTicket, getTicketById, closeTicketApi, answerTicket, GetAllOrders } from '../../utils/api'
import useToastNotification from '../../hooks/useToastNotification';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import moment from 'jalali-moment';

function AddTicket({ ticketId, ticketDetail }) {
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [ticketData, setTicketData] = useState(null);
    const [messages, setMessages] = useState(null);
    const [orderNumber, setOrderNumber] = useState('');
    const [description, setDescription] = useState('');
    const [title, setTitle] = useState('');
    const [answer, setAnswer] = useState('');
    const [file, setFile] = useState(null);
    const [orderList, setOrderList] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const { showError, showSuccess } = useToastNotification();
    const navigate = useNavigate(); // useNavigate for navigation without refresh
    const [userName, setUserName] = useState("");
    const [filePreview, setFilePreview] = useState(null);


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userInfo"));
        console.log(user)
        setUserName(user.fullname);


    }, []);
    const mahiyatOption = [
        { name: 'حقیقی', code: 'B' },
        { name: 'حقوقی', code: 'C' },
    ];

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilePreview(reader.result); // base64 image preview
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setFilePreview(null);
        }
    };


    const handleFileClick = () => {
        document.getElementById('file-upload').click();
    };
    const ordersData = async (pay) => {
        try {
            let res = await GetAllOrders(pay);
            if (res.status === 200) {
                setOrderList(res.data);
            }
        } catch (error) {
            showError('خطا در دریافت سفارشات');
        }
    };
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 12);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {
            fromDate: convertDateToPersian(fromDateNew),
            toDate: convertDateToPersian(new Date()),
            userId: JSON.parse(customerDatares).si,
            status: '',
            factorNum: ''
        };

        ordersData(pay);
    }, []);
    const handleSubmit = async (e) => {
        console.log('.....')
        e.preventDefault();
        if (!title || !description) {
            setValidated(true);
            return;
        }
        try {
            let pay = {
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                id: ticketId,
                answer: answer
            }
            let res = await answerTicket(pay)
            if (res.status == 200) {
                showSuccess('ثبت شد')
                window.location.reload();
            }


        } catch (error) {

        }
        // Your logic for handling the form submission, including file upload if needed
    };

    const getTicketByIdfun = async () => {
        try {
            let pay = {
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                ticketId: ticketId
            }
            let res = await getTicketById(pay)
            setTicketData(res.data)

            let resMessage = await getMessageTicket(pay)
            setMessages(resMessage.data)
        } catch (error) {

        }
    }
    useEffect(() => {
        setTimeout(() => {

            getTicketByIdfun()
        }, 500);
    }, [])

    const fetchCloseTicket = async () => {
        try {
            let pay = {
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                id: ticketId
            }
            console.log(pay)
            let res = await closeTicketApi(pay)
            console.log(res)
            if (res.status == 200) {
                showSuccess("تیکت بسته شد.")
                window.location.reload();
            }
        } catch (error) {

        }
    }
    return (
        <>
            <Form className='mb-4' noValidate validated={validated} onSubmit={handleSubmit}>
                <div className='row gx-5 gy-2'>
                    <Form.Group className="col-md-6 col-lg-4 col-sm-12">
                        <Form.Label>سفارش مربوطه <span className='text-[red]'> * </span></Form.Label>
                        <Dropdown value={orderNumber} onChange={(e) => setOrderNumber(e.value)} options={orderList} optionLabel="Si" className="w-100 " />
                    </Form.Group>

                    <Form.Group className="col-md-6 col-lg-4 col-sm-12">
                        <Form.Label>موضوع <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control type="text" required value={ticketData?.onvan} onChange={(e) => setTitle(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            موضوع را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                {messages?.map((msg) => (
                    <div>
                        {msg.Writer == userName ? (
                            <div className='row gx-5 gy-2 mt-4 px-3'>
                                <Form.Label className='p-0'>پیام شما </Form.Label>
                                <Form.Group className="col-md-6 col-lg-8 col-sm-12 border-1 py-2 px-1 rounded-xl !border-[#d7d7d7]">
                                    <div className='border-0 text-sm text-right px-2 pb-3'  >{msg?.Matn}</div>
                                    <img src={msg?.Attached} alt="" width={120} />
                                </Form.Group>
                            </div>
                        ) : (
                            <div className='row gx-5 gy-2 mt-4 px-3'>
                                <Form.Label className='p-0 text-[#00a14b]'>پاسخ تیم پشتیبان </Form.Label>
                                <Form.Group className="col-md-6 col-lg-8 col-sm-12 border-1 py-2 px-1 rounded-xl !border-[#d7d7d7]">
                                    <div className='border-0 text-sm text-right px-2 pb-3'  >{msg?.Matn}</div>
                                    <img src={msg?.Attached} alt="" width={120} />
                                </Form.Group>
                            </div>
                        )}


                    </div>
                )
                )}
                {ticketDetail.Active != 'C' && (
                    <>
                        <div className='row gx-5 gy-2 mt-4'>
                            <Form.Group className="col-md-6 col-lg-8 col-sm-12">
                                <Form.Label>پاسخ <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control type="text" as="textarea" rows={3} required value={answer} style={{ minHeight: '120px' }} onChange={(e) => setAnswer(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                                    توضیحات را وارد کنید.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>

                        <div className="row gx-5 gy-2 mt-4">
                            <Form.Group className="col-md-6 col-lg-8 col-sm-12">
                                <div className="file-upload-container" onClick={handleFileClick}>
                                    <input type="file" onChange={handleFileChange} id="file-upload" style={{ display: 'none' }} />
                                    <img src={UploadIcon} alt="Upload Icon" />
                                    <h6 className='text-xs font-medium mt-2'>
                                        {file ? file.name : 'فایل مورد نظر را آپلود کنید.'}
                                    </h6>
                                </div>
                            </Form.Group>
                            {filePreview && (
                                <div className=' '>
                                    <img src={filePreview} alt="Preview" className="img-preview mt-2 aspect-[4/4] rounded-lg" width={150} />
                                </div>
                            )}
                        </div>
                    </>
                )}
                <div className="mt-4 d-flex align-items-center justify-content-end gap-2">
                    {ticketDetail.Active != 'C' && (
                        <button type='button' className='btn btn-outline-primary w-[140px]' onClick={fetchCloseTicket}>بستن تیکت</button>
                    )}
                    <button type='submit' className='btn btn-primary w-[140px]'>ارسال</button>
                </div>
            </Form>
        </>
    );
}

export default AddTicket;
